import { createSlice } from '@reduxjs/toolkit';
import { getDeletedNotifications, saveDeletedNotifications } from '../../utils/notificationStorage';

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: [],
  reducers: {
    addpulkNotification: (state, action) => {
      const deletedIds = getDeletedNotifications();
      action.payload?.forEach((notif) => {
        if (!deletedIds.includes(notif.NotifyId)) {
          const index = state.findIndex(n => n.NotifyId == notif.NotifyId);
          if (index < 0) {
            state.unshift(notif);
          }
        }
      });
    },

    addNotification: (state, action) => {
      const deletedIds = getDeletedNotifications();
      if (!deletedIds.includes(action.payload?.NotifyId)) {
        const index = state.findIndex(n => n.NotifyId == action.payload?.NotifyId);
        if (index < 0) {
          state.unshift(action.payload);
        }
      }
    },

    markAsRead: (state, action) => {
      const index = state.findIndex(n => n.NotifyId == action.payload);
      if (index !== -1) {
        state[index].read = true;
      }
    },

    markAllAsRead: (state) => {
      state.forEach(n => n.read = true);
    },

    clearNotifications: (state) => {
      const allIds = state.map(n => n.NotifyId);
      saveDeletedNotifications(allIds);
      return []; // تفريغ الحالة
    }
  }
});

export const {
  addNotification,
  addpulkNotification,
  markAsRead,
  markAllAsRead,
  clearNotifications
} = notificationSlice.actions;

export default notificationSlice.reducer;

// في أعلى أو أسفل الملف notificationSlice.js
export const tryAddNotification = (notif) => (dispatch, getState) => {
    const state = getState().notifications;
    const exists = state.find(n => n.NotifyId === notif.NotifyId);

    if (!exists) {
        dispatch(addNotification(notif));
        return true; // تمت الإضافة
    }
    return false; // لم تُضف
};
